import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { ChangeTaskService } from 'src/app/services/api/change-task.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import { AnimationsService } from 'src/app/services/util/animations.service';

@Component({
    selector: 'app-defer-update-dialog',
    templateUrl: './defer-update-dialog.component.html',
    styleUrls: ['./defer-update-dialog.component.scss'],
    animations: [AnimationsService.ENTER_EASE_OUT_FROM_RIGHT('updateSuccessful')],
    standalone: false
})
export class DeferUpdateDialogComponent implements OnInit {

  deferred: boolean;
  hasError: boolean;
  dataLoading: boolean;
  deferralReasonControl: FormControl;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public matDialogRef: MatDialogRef<DeferUpdateDialogComponent>,
              private changeTaskService: ChangeTaskService) {
  }

  ngOnInit(): void {
    this.deferralReasonControl = new FormControl(undefined, [Validators.required, Validators.maxLength(512)]);
  }

  deferUpdate(): void {
    if (this.deferralReasonControl.invalid) {
      return;
    }
    this.dataLoading = true;
    this.changeTaskService.deferUpdate(this.data.changeTaskId, this.deferralReasonControl.value)
        .pipe(
          finalize(() => this.dataLoading = false),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(
          () => this.deferred = true,
          () => this.hasError = true
        );
  }
}
